import { Button } from "@/components/ui/button";

export const AccessDenied = () => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-6 p-6 bg-muted">
    <div className="text-center max-w-md">
      <div className="text-5xl mb-4">🔒</div>
      <h1 className="text-2xl font-semibold text-foreground mb-3">Access Denied</h1>
      <p className="text-base text-muted-foreground mb-6 leading-relaxed">
        This add-in can only be accessed from within Microsoft Outlook.
        Please install the add-in and open it from your Outlook mailbox.
      </p>
      <Button asChild>
        <a href="/">Go to Homepage</a>
      </Button>
    </div>
  </div>
);
